import { Button, Space, Tag } from 'antd';

interface TagListProps {
  names: string[];
  showCopyButton?: boolean;
}

export const TagList = ({ names, showCopyButton }: TagListProps) => {
  return names?.length > 0 ? (
    <Space wrap>
      {names.map((groupName) => {
        return (
          <Tag key={groupName} style={{ margin: 0 }}>
            {groupName}
          </Tag>
        );
      })}
      {showCopyButton && (
        <Button
          size="small"
          style={{ fontSize: '0.75rem', padding: '0' }}
          title="Copy"
          type="link"
          onClick={() => navigator.clipboard?.writeText(names.join(', '))}
        >
          Copy
        </Button>
      )}
    </Space>
  ) : (
    <div>None</div>
  );
};
